routes.$inject = ['$stateProvider'];

export default function routes($stateProvider) {

    $stateProvider.state('main.appNotificationClick', {
        url: '/appNotificationClick/:panelId',
        resolve: {
            panels: [
                '$stateParams', '$q', 'ApiPanelsService',
                ($stateParams, $q, ApiPanelsService,) => {
                    let deferred = $q.defer();

                    ApiPanelsService.panels().then((resp) => {
                        let panels = resp.results;
                        deferred.resolve(panels);
                    });

                    return deferred.promise;
                }
            ]
        },
        controller: ['panels', '$stateParams', '$state', function (panels, $stateParams, $state,) {
            $state.go('main.panel.control', {id: panels[_.indexOf(_.map(panels, 'control_panel.id'), Number($stateParams.panelId))].id});
        }]
    })
}


/** WEBPACK FOOTER **
 ** ./src/main/appNotificationClick/routes.js
 **/